"use client";

import {
  ButtonChangeLayout,
  ButtonIcon,
  Image,
  Link,
  Profile,
  View
} from "@/components";

import type { NavProps } from "@/components/types";

const TopNavHorizontal = ({ setSidebarIsOpen }: NavProps) => (
  <View
    type="nav"
    className="bg-[#F7F7FE] dark:bg-bg3 shadow-md w-full mx-auto fixed z-40"
  >
    <View
      className={`px-3 py-3 duration-300 navbar-top z-30 max-w-[1700px] w-full mx-auto md:py-4 xl:py-6 gap-3 flex justify-between items-center`}
    >
      <View className="flex justify-between items-center">
        <Link href="/">
          <Image
            width={174}
            height={38}
            src="/img/logo.svg"
            alt="logo"
            className="hidden lg:block"
          />
        </Link>
        <ButtonIcon
          action={() => setSidebarIsOpen(false)}
          className="xxl:hidden"
          iconLeft={{ name: "bars" }}
        />
      </View>
      <View className="flex items-center gap-3 sm:gap-4 xxl:gap-6">
        {/* <ModeSwitcher /> */}
        {/* <Notification /> */}
        {/* <SwitchLanguage /> */}
        {/* <Profile className="hidden md:block" /> */}
        {/* <Search /> */}
        <Profile />
      </View>
    </View>
    <ButtonChangeLayout
      sidebarIsOpen={false}
      onClick={() => setSidebarIsOpen(true)}
    />
  </View>
);

export default TopNavHorizontal;
